import React from "react";
import CreatableSelect from "react-select/creatable";
import "./CompanyFilter.css";

export default function CompanyFilter({
  filterOptions,
  includeCompanies,
  setIncludeCompanies,
  excludeCompanies,
  setExcludeCompanies
}) {
  // Convert backend options → react-select format
  const companyOptions =
    filterOptions?.companies?.map((c) => ({ label: c, value: c })) || [];

  // Convert string arrays → react-select format
  const toSelect = (arr) => arr.map((v) => ({ label: v, value: v }));

  // Convert back to plain string list
  const fromSelect = (arr) => arr?.map((v) => v.value) || [];

  return (
    <>
      {/* Include Companies */}
      <div className="hf-filter-item">
        <label>Include Companies</label>
        <CreatableSelect
          options={companyOptions}
          value={toSelect(includeCompanies)}
          onChange={(vals) => setIncludeCompanies(fromSelect(vals))}
          isMulti
          isClearable
          className="hf-select"
          classNamePrefix="hf"
          placeholder="Type or select..."
          formatCreateLabel={(input) => `Add "${input}"`}
        />
      </div>

      {/* Exclude Companies */}
      <div className="hf-filter-item">
        <label>Exclude Companies</label>
        <CreatableSelect
          options={companyOptions}
          value={toSelect(excludeCompanies)}
          onChange={(vals) => setExcludeCompanies(fromSelect(vals))}
          isMulti
          isClearable
          className="hf-select"
          classNamePrefix="hf"
          placeholder="Type or select..."
          formatCreateLabel={(input) => `Add "${input}"`}
        />
      </div>
    </>
  );
}



// import React, { useState } from "react";
// import "./CompanyFilter.css";

// export default function CompanyFilter({
//   filterOptions,
//   includeCompanies,
//   setIncludeCompanies,
//   excludeCompanies,
//   setExcludeCompanies
// }) {
//   const [incInput, setIncInput] = useState("");
//   const [excInput, setExcInput] = useState("");

//   const handleAdd = (value, setter, list) => {
//     if (!value.trim()) return;
//     if (!list.includes(value.trim())) {
//       setter([...list, value.trim()]);
//     }
//   };

//   return (
//     <>
//       {/* Include Companies */}
//       <div className="hf-filter-item hf-company-col">
//         <label>Include Companies</label>

//         <div className="hf-input-wrapper">
//           <input
//             type="text"
//             placeholder="Type & press Enter"
//             value={incInput}
//             onChange={(e) => setIncInput(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 handleAdd(incInput, setIncludeCompanies, includeCompanies);
//                 setIncInput("");
//               }
//             }}
//           />

//           {filterOptions?.companies && incInput.length > 1 && (
//             <div className="hf-autocomplete">
//               {filterOptions.companies
//                 .filter((c) =>
//                   c.toLowerCase().includes(incInput.toLowerCase())
//                 )
//                 .slice(0, 8)
//                 .map((c) => (
//                   <div
//                     key={c}
//                     className="hf-autocomplete-item"
//                     onClick={() => {
//                       handleAdd(c, setIncludeCompanies, includeCompanies);
//                       setIncInput("");
//                     }}
//                   >
//                     {c}
//                   </div>
//                 ))}
//             </div>
//           )}

//           <div className="hf-chip-row">
//             {includeCompanies.map((c) => (
//               <span key={c} className="hf-chip">
//                 {c}
//                 <button
//                   onClick={() =>
//                     setIncludeCompanies(includeCompanies.filter((x) => x !== c))
//                   }
//                 >
//                   ×
//                 </button>
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Exclude Companies */}
//       <div className="hf-filter-item hf-company-col">
//         <label>Exclude Companies</label>

//         <div className="hf-input-wrapper">
//           <input
//             type="text"
//             placeholder="Type & press Enter"
//             value={excInput}
//             onChange={(e) => setExcInput(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 handleAdd(excInput, setExcludeCompanies, excludeCompanies);
//                 setExcInput("");
//               }
//             }}
//           />

//           {filterOptions?.companies && excInput.length > 1 && (
//             <div className="hf-autocomplete">
//               {filterOptions.companies
//                 .filter((c) =>
//                   c.toLowerCase().includes(excInput.toLowerCase())
//                 )
//                 .slice(0, 8)
//                 .map((c) => (
//                   <div
//                     key={c}
//                     className="hf-autocomplete-item"
//                     onClick={() => {
//                       handleAdd(c, setExcludeCompanies, excludeCompanies);
//                       setExcInput("");
//                     }}
//                   >
//                     {c}
//                   </div>
//                 ))}
//             </div>
//           )}

//           <div className="hf-chip-row">
//             {excludeCompanies.map((c) => (
//               <span key={c} className="hf-chip hf-chip-red">
//                 {c}
//                 <button
//                   onClick={() =>
//                     setExcludeCompanies(excludeCompanies.filter((x) => x !== c))
//                   }
//                 >
//                   ×
//                 </button>
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
